var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Input, Select } from "semantic-ui-react";
import * as countries from './countries.json';
import FieldWithErrorDisplay from "./FieldWithErrorDisplay";
import * as states from './us-states.json';
var AddressEditForm = /** @class */ (function (_super) {
    __extends(AddressEditForm, _super);
    function AddressEditForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onStreetChange = function (event) {
            _this.props.setAddressState({ street: event.currentTarget.value });
        };
        _this.onStreetLine2Change = function (event) {
            _this.props.setAddressState({ streetLine2: event.currentTarget.value });
        };
        _this.onCityChange = function (event) {
            _this.props.setAddressState({ city: event.currentTarget.value });
        };
        _this.onZipChange = function (event) {
            _this.props.setAddressState({ zipPostalCode: event.currentTarget.value });
        };
        _this.onUsStateChange = function (event, data) {
            var val = data.value;
            if (typeof val !== 'string') {
                throw new Error("Unexpected state value: " + val);
            }
            _this.props.setAddressState({
                stateProvince: val
            });
        };
        _this.onNonUsStateChange = function (event, data) {
            var val = data.value;
            _this.props.setAddressState({
                stateProvince: val
            });
        };
        _this.onCountryChange = function (event, data) {
            var val = data.value;
            if (typeof val !== 'string') {
                throw new Error("Unexpected country value: " + val);
            }
            _this.props.setAddressState({
                countryCode: val
            });
        };
        _this.isUs = function (countryCode) {
            return countryCode === 'US';
        };
        return _this;
    }
    AddressEditForm.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 16 },
                    React.createElement(FieldWithErrorDisplay, { disabled: this.props.disabled, errorPath: this.props.errorPathPrefix + "/street", errors: this.props.errors, labelContent: React.createElement(React.Fragment, null, "Street Address"), required: true },
                        React.createElement(Input, { value: this.props.address.street, onChange: this.onStreetChange })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { width: 16 },
                    React.createElement(FieldWithErrorDisplay, { disabled: this.props.disabled, errorPath: this.props.errorPathPrefix + "/streetLine2", errors: this.props.errors, labelContent: React.createElement(React.Fragment, null, "Room/Suite/Other") },
                        React.createElement(Input, { value: this.props.address.streetLine2, onChange: this.onStreetLine2Change })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { disabled: this.props.disabled, errorPath: this.props.errorPathPrefix + "/city", errors: this.props.errors, labelContent: React.createElement(React.Fragment, null, "City"), required: true },
                        React.createElement(Input, { value: this.props.address.city, onChange: this.onCityChange }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { disabled: this.props.disabled, errorPath: this.props.errorPathPrefix + "/stateProvince", errors: this.props.errors, labelContent: React.createElement(React.Fragment, null, "State / Province") }, this.isUs(this.props.address.countryCode)
                        ? React.createElement(Select, { search: true, onChange: this.onUsStateChange, options: AddressEditForm.US_STATE_OPTIONS, value: this.props.address.stateProvince })
                        : React.createElement(Input, { type: 'text', onChange: this.onNonUsStateChange, value: this.props.address.stateProvince }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { disabled: this.props.disabled, errorPath: this.props.errorPathPrefix + "/zipPostalCode", errors: this.props.errors, labelContent: React.createElement(React.Fragment, null, "Zip / Postal Code"), required: true },
                        React.createElement(Input, { value: this.props.address.zipPostalCode, onChange: this.onZipChange, placeholder: '12345' })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { disabled: this.props.disabled, errorPath: this.props.errorPathPrefix + "/countryCode", errors: this.props.errors, labelContent: React.createElement(React.Fragment, null, "Country"), required: true },
                        React.createElement(Select, { search: true, options: AddressEditForm.COUNTRY_OPTIONS, onChange: this.onCountryChange, value: this.props.address.countryCode })))));
    };
    AddressEditForm.US_STATE_OPTIONS = states.map(function (obj) {
        return {
            value: obj.value,
            text: obj.text
        };
    });
    AddressEditForm.COUNTRY_OPTIONS = countries.map(function (obj) {
        return {
            value: obj.value,
            text: obj.text
        };
    });
    return AddressEditForm;
}(React.PureComponent));
export default AddressEditForm;
//# sourceMappingURL=AddressForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/AddressForm.js
// module id = 311
// module chunks = 0